module.exports = __webpack_public_path__ + "img/device-wipe.b7d07fd5.svg";